export default __webpack_public_path__ + "static/instagram_logo-aaa207e2a8befba561209506ba372a4e.png";